import axios from "@/lib/axios";
import { InscriptionFormType } from "@/types/edition";

export type ApplyForEditionRequestForm = {
  resourceId: string;
  formType: InscriptionFormType; // This is more like an attahcment type
  name: string;
};

export type ApplyForEditionRequestParams = {
  companyId: string;
  editionId: string;
  forms: ApplyForEditionRequestForm[];
};

type ApplyForEditionResponse = void;

export const applyForEdition = (params: ApplyForEditionRequestParams) =>
  axios
    .post<ApplyForEditionResponse>(
      `/v1/companies/${params.companyId}/applications`,
      { editionId: params.editionId, forms: params.forms },
    )
    .then((res) => res.data);
